<template>
  <v-app id="nav">
    <Header />
    <router-view />
  </v-app>
</template>
<script>
import Header from "./components/layouts/Header";
export default {
  components: {
    Header,
  },
};
</script>
<style>
/* @font-face {
  src: url(./assets/fonts/ChaletBookRegular.ttf);
  font-family:ChaletBook;
} */
#app {
  font-family: "DM Sans";
  font-size: 15px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#nav a {
  color: #0077b6;
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
}

#nav a.router-link-exact-active {
  color: #0079bc;
}
</style>
